// UI（器）の文言 — 日本語。方針とキー規約は en/common.ts の冒頭を参照。
// **en/common.ts とキー集合を必ず揃える**こと。

export default {
  'nav.top': 'TOP',
  'nav.lyrics': '歌詞',
  'nav.linerNotes': 'ライナーノーツ',
  'nav.menu': 'メニュー',

  'lang.label': '言語',
  'lang.en': 'EN',
  'lang.ja': '日本語',

  'hero.shareText': '「{{title}}」{{artist}} 好評配信中！',
  'hero.jacketAlt': '{{title}} - {{artist}} ジャケット写真',
  'hero.shareOnX': 'Xでシェア',
  'hero.shareOnFacebook': 'Facebookでシェア',
  'hero.shareOnLine': 'LINEでシェア',
  'hero.copyUrl': 'URLをコピー',

  'overview.title': 'シングル概要',
  'overview.artist': 'アーティスト',
  'overview.releaseDate': 'リリース日',
  'overview.label': 'レーベル',
  'overview.genre': 'ジャンル',
  'overview.credits': 'クレジット',
  'overview.viewLyrics': '歌詞を見る',
  'overview.readLinerNotes': 'ライナーノーツを読む',

  'timeline.title': 'リリース情報',

  'lyrics.note': '日本語超訳 by Gen.Y.Sakai',
  'linerNotes.note': 'ライナーノーツ 日本語版 by Gen.Y.Sakai',
};
